import { render, staticRenderFns } from "./WorkCalendar.vue?vue&type=template&id=45dbe6df&scoped=true"
import script from "./WorkCalendar.vue?vue&type=script&lang=js"
export * from "./WorkCalendar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendar.vue?vue&type=style&index=0&id=45dbe6df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dbe6df",
  null
  
)

export default component.exports